import type { MetaDto } from '@dbrain/shared';

/** The experience an address opens (decision 2026-10-27); with one address, the remembered choice. */
export type Experience = 'chat' | 'code';

export function experienceFor(meta: MetaDto | undefined, origin: string, stored: string | null): Experience {
  if (meta?.codeOrigin && origin === meta.codeOrigin) return 'code';
  if (meta && origin === meta.chatOrigin && meta.codeOrigin) return 'chat';
  return stored === 'code' ? 'code' : 'chat';
}

/**
 * D-153: an address that is neither of the two (the server's IP address after the move to a domain) sends the
 * browser to the https address of its experience: the IP address's code port (8481, D-142) to CompanyCode, any other
 * to CompanyGPT. Null on one of the two addresses, and whenever they are not both https (an installation on an IP
 * address, a development stack), so a mistaken setting never sends anyone in circles.
 */
/** The parts of the browser's `location` it reads (no DOM types here: the native app shares this module). */
export interface Here {
  origin: string;
  port: string;
  pathname: string;
  search: string;
  hash: string;
}

export function canonicalAddress(meta: MetaDto | undefined, here: Here): string | null {
  if (!meta?.codeOrigin || !meta.chatOrigin.startsWith('https://') || !meta.codeOrigin.startsWith('https://')) return null;
  if (here.origin === meta.chatOrigin || here.origin === meta.codeOrigin) return null;
  const origin = here.port === '8481' ? meta.codeOrigin : meta.chatOrigin;
  return `${origin}${here.pathname}${here.search}${here.hash}`;
}
